import { render, staticRenderFns } from "./buyerContract.vue?vue&type=template&id=43404e4f&scoped=true"
import script from "./buyerContract.vue?vue&type=script&lang=js"
export * from "./buyerContract.vue?vue&type=script&lang=js"
import style0 from "./buyerContract.vue?vue&type=style&index=0&id=43404e4f&prod&lang=less"
import style1 from "./buyerContract.vue?vue&type=style&index=1&id=43404e4f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43404e4f",
  null
  
)

export default component.exports